import React from "react";
import styles from "./MainAccordionSideBySide.module.css";
import { landStoryIds } from "../../interfaces";

interface Props {
  activeStoryId?: landStoryIds;
  changeStory: (storyId: landStoryIds) => void;
}

const MainAccordionSideBySide: React.FC<Props> = ({ activeStoryId, changeStory }) => {
  return (
    <div className={styles.root}>
      <div
        className={`${styles.card} ${
          activeStoryId === "aap" ? styles.cardActive : ""
        }`}
        onClick={() => changeStory("aap")}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") changeStory("aap");
        }}
      >
        <div className={styles.cardHeader}>
          <span
            className={`${styles.dot} ${
              activeStoryId === "aap" ? styles.dotActive : ""
            }`}
          />
          <span className={styles.title}>Autonomous Accounts Payable</span>
        </div>

        <p className={styles.meta}>
          First on market autonomous accounting fully verifying and reconciling invoices with +99% success rate.
        </p>
      </div>

      <div
        className={`${styles.card} ${
          activeStoryId === "acc" ? styles.cardActive : ""
        }`}
        onClick={() => changeStory("acc")}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") changeStory("acc");
        }}
      >
        <div className={styles.cardHeader}>
          <span
            className={`${styles.dot} ${
              activeStoryId === "acc" ? styles.dotActive : ""
            }`}
          />
          <span className={styles.title}>Autonomous Call Center</span>
        </div>

        <p className={styles.meta}>
          Highly intelligent and blazingly fast call center operator ready to fully take over support/training/screening in EU languages.
        </p>
      </div>
    </div>
  );
};

export default MainAccordionSideBySide;
